import { render } from "./TransactionsReport.vue?vue&type=template&id=053a8384&scoped=true"
import script from "./TransactionsReport.vue?vue&type=script&lang=js"
export * from "./TransactionsReport.vue?vue&type=script&lang=js"

import "./TransactionsReport.vue?vue&type=style&index=0&id=053a8384&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-053a8384"

export default script